<template src="./DashboardFinancial.html"></template>

<script>
import mixins from "../../../../Mixins.js";
import SearchByDate from "@/components/search-by-date/SearchByDate.vue";

export default {
  mixins: [mixins],
  components: { SearchByDate },
  data() {
    return {
      netBalance: 0,
      totalInactivated: 0,
      totalAccountMaster: 0,
      totalBlockAndFiloo: 0,
      totalBalanceBlockFiloo: 0,
      totalBalanceClient: 0,
      totalBalanceDoctor: 0,
      historic: [],
      conciliationBalance: [],
      radialBarChart: {
        series: [0, 2, 3, 4],
        chartOptions: {
          colors: ["#F06428", "#147877", "#508cc8", "#3c6997"],
          plotOptions: {
            radialBar: {
              dataLabels: {
                name: {
                  fontSize: "14px"
                },
                value: {
                  fontSize: "14px"
                },
                total: {
                  show: true,
                  label: "Conta Master",
                  formatter: function() {
                    var total = 100;
                    //w.globals.seriesTotals[0] + w.globals.seriesTotals[4];
                    return total + "%";
                  }
                }
              }
            }
          },
          labels: [
            "Saldo líquido",
            "Saldo clientes",
            "Saldo profissionais",
            "Saldo inativos"
          ]
        }
      },
      options: {
        legend: {
          position: "bottom",
          horizontalAlign: "center",
          itemMargin: {
            horizontal: 14,
            vertical: 60
          }
        },
        colors: ["#FF0000", "#508cc8", "#3c6997", "#78c8be"],
        labels: [
          "Saldo inativos",
          "Saldo profissionais",
          "Saldo clientes",
          "Saldo líquido"
        ]
      },
      series: [0, 1, 2, 3],
      date: {
        initial: null,
        final: null,
      },
      searchUrl: ""
    };
  },
  mounted: function() {
    const vm = this;
    vm.init();
  },
  methods: {
    init() {
      const vm = this;
      vm.getTransactions();
    },
    updateChart() {
      const vm = this;
      vm.netBalance = vm.totalAccountMaster - vm.totalBalanceClient;
      vm.series = [
        vm.round(vm.totalInactivated, 2),
        vm.round(vm.totalBalanceDoctor, 2),
        vm.round(vm.totalBalanceClient, 2),
        vm.round(vm.netBalance, 2)
      ];

      var percentBalanceDoctor =
        (vm.totalBalanceDoctor * 100) / vm.totalAccountMaster;
      var percentBalanceClient =
        (vm.totalBalanceClient * 100) / vm.totalAccountMaster;
      var percentInactivated =
        (vm.totalInactivated * 100) / vm.totalAccountMaster;
      var percentNetBalance = (vm.netBalance * 100) / vm.totalAccountMaster;
      vm.radialBarChart.series = [
        vm.round(percentNetBalance, 2),
        vm.round(percentBalanceClient, 2),
        vm.round(percentBalanceDoctor, 2),
        vm.round(percentInactivated, 2)
      ];
    },
    getAllConciliationListFundsFiloo() {
      const vm = this;
      const dateUrl = vm.getDates();
      const baseUrl = vm.$store.state.filooServer + "payment/get-conciliation-list-funds-filoo/with-date";
      const url = baseUrl + dateUrl;
      var bearer = vm.$session.get("bearer");
      vm.axios
        .get( url, { headers: { Authorization: bearer }})
        .then(function(response) {
          if (response.status === 200) {
            vm.historic = response.data;
            vm.sumBalance(vm.historic);
          }
        });
    },
    getTransactions() {
      const vm = this;
      vm.resetValues();
      const dateUrl = vm.getDates();
      const baseUrl = vm.$store.state.filooServer + "payment/get-transaction-report/search-without-page";
      const url = baseUrl + dateUrl;
      vm.$vs.loading();
      var bearer = vm.$session.get("bearer");
      vm.axios
        .get(url, { headers: { Authorization: bearer }})
        .then(function(response) {
          if (response.status === 200) {
            vm.conciliationBalance = response.data;
            vm.$nextTick(function() {
              if (vm.conciliationBalance.length > 0) {
                vm.totalAccountMaster =
                  vm.conciliationBalance[
                    vm.conciliationBalance.length - 1
                  ].balance;
              }
              vm.$vs.loading.close();
              setTimeout(function() {
                vm.getAllConciliationListFundsFiloo();
              }, 200);
            });
          }
        });
    },
    sumBalance(historic) {
      const vm = this;
      var i = 0;
      for (i = 0; i < historic.length; i++) {
        vm.totalBalanceBlockFiloo += historic[i].saldoBlock;
        if (historic[i].tipo === "Cliente" && historic[i].status === "Ativo") {
          vm.totalBalanceClient += historic[i].saldoFiloo;
        }
        if (historic[i].tipo === "Médico" && historic[i].status === "Ativo") {
          vm.totalBalanceDoctor += historic[i].saldoFiloo;
        }
        if (historic[i].status === "Inativo" && historic[i].walletId > 0) {
          vm.totalInactivated += historic[i].saldoFiloo;
        }
      }
      vm.updateChart();
    },
    updateSearchDate(date) {
      const vm = this;
      vm.date = date;
      vm.getTransactions()
    },
    getDates() {
      const vm = this;
      const date =
        vm.testNullUndefinedEmpty(vm.date) ||
        vm.testNullUndefinedEmpty(vm.date.final)
          ? ""
          : "?initialDate=2018-01-01&finalDate=" + vm.date.final;
      return date;
    },
    resetValues() {
      const vm = this;
      vm.netBalance = 0,
      vm.totalInactivated = 0,
      vm.totalAccountMaster = 0,
      vm.totalBlockAndFiloo = 0,
      vm.totalBalanceBlockFiloo = 0,
      vm.totalBalanceClient = 0,
      vm.totalBalanceDoctor = 0,
      vm.historic = [],
      vm.conciliationBalance = []
    }
  }
};
</script>

<style src="./DashboardFinancial.css">
</style>
